import { CART_RESTAPI, CART_REQUEST, CART_ERROR, CART_SUCCESS, CART_ADD , CART_UPDATE,CART_VALIDATE, CART_MODE,CART_DELETE,CART_PURCHASE,  CART_PURCHASE_PENDING, CART_PURCHASE_SUCCESS, CART_PURCHASE_FAILURE} from "../actions/cart";
import apiCall from "../../utils/api";
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";
import axios from "axios";

const state = {
  mode: "Interactive",
  status: "", editable: true,
  defaultPrice: "24.99",
  products: [],
  orders: [],
axiosData: {},
RESTAPI: "",
 };

const getters = {
  getEditable: state => state.editable,
  getProducts: state => state.products,
  getOrders: state => state.orders,
  getCartAxiosData: state => state.axiosData,
};

const actions = {
  [CART_REQUEST]: ({ commit, dispatch,rootGetters },parameters) => {
    console.log("**CART_REQUEST***");
    console.log(parameters);
    console.log(state.reportViewParameters);

    // get the credentials from the auth module
    console.log(rootGetters);
    console.log(rootGetters.authCredentials);

    var p = state.reportViewParameters
    console.log("**CART_REQUEST-- var p***");
    console.log(p);
    commit(CART_REQUEST);
    var URI = state.RESTAPI + "/api/Reports/Norm";
    const options = {
      headers: {'X-Token': rootGetters.authToken}
    };
    axios
      .post(URI, {naics: p.naics, range: p.range, state: p.state, zip: p.zip },options)
      .then(r => {
        console.log("**Axios Response-then***");
    console.log(r)

      commit(CART_SUCCESS,r.data);

      })
      .catch(err => {
        console.log("**Axios Response-catch***");
        commit(CART_ERROR);
        reject(err);
      });



  },
  [CART_PURCHASE]: ({ commit, dispatch,rootGetters },PayPalResponse) => {
    console.log("**CART_PURCHASE***");
    console.log("PayPalResponse",PayPalResponse);

    // get the credentials from the auth module
    console.log(rootGetters);
    console.log(rootGetters.authCredentials);

    var paypalJSON = JSON.stringify(PayPalResponse)
    var total = 0.0
    state.orders.forEach((element, index, array) => {
      total = total + parseFloat(element.price)
      });

    commit(CART_PURCHASE_PENDING);
    var URI = state.RESTAPI + "/api/Order/Purchase";
    const options = {
      headers: {'X-Token': rootGetters.authToken}
    };
    axios
      .post(URI, { userid: rootGetters.authCredentials.email, totalprice: total ,  paypaljson: paypalJSON, orders: state.orders},options)
      .then(r => {
        console.log("**Axios Response-then***");
    console.log(r)

      commit(CART_PURCHASE_SUCCESS);

      })
      .catch(err => {
        console.log("**Axios Response-catch***");
        commit(CART_PURCHASE_FAILURE);
        reject(err);
      });



  }
};

const mutations = {
  [CART_PURCHASE_PENDING]: (state) => {
    console.log("**CART_PURCHASE_PENDING-mutation***");
    state.status = "cart-purchase-pending";
  },
  [CART_PURCHASE_SUCCESS]: (state) => {
    console.log("**CART_PURCHASE_SUCCESS-mutation***");
    state.status = "cart-purchase-success";
    state.products = []
    state.orders = []
    // empty the orders and the products after a successful purchase
  },
  [CART_PURCHASE_FAILURE]: (state) => {
    console.log("**CART_PURCHASE_FAILURE-mutation***");
    state.status = "cart-purchase-failure";
  },
    [CART_ADD]: (state,myproduct) => {
    console.log("**CART_ADD-mutation***");
    console.log(myproduct);
    state.status = "cart-adding";
    state.editable = true

  var product = { cartProduct: myproduct, price: state.defaultPrice, index: state.products.length+1, render:{message: "", type: "is-info" }  }
    state.products.push(product)
    state.status = "cart-added";

  },
    [CART_VALIDATE]: (state,parameters) => {
    console.log("**CART_VALIDATE-mutation--start***",state.status);
    console.log(parameters);
    state.status = "cart-validating";

    state.status = "cart-validating-success";

    state.products.forEach((element, index, array) => {
      var rowvalid = true
      // the b-fields are indexed according to the row index, not the array index

      var xindex = state.products[index].index
      console.log("-----products.foreach: index,xindex",index,xindex)
      console.log("-----products.foreach: element",element)
      // if the element doesnt exist in the array then it is not selected
      if( typeof parameters.select[xindex] === 'undefined' ) {
        state.products[index].render.message  = "Make a Sales Selection"
        state.products[index].render.type = "is-danger"
        rowvalid = false
        console.log("products.foreach-failed-1",element)
      } else if ( parameters.select[xindex] == "Choose Sales Size") {
        state.products[index].render.message  = "Make a Sales Selection"
        state.products[index].render.type = "is-danger"
        rowvalid = false
        console.log("products.foreach-failed-2",element)
      } else {
          if (parameters.select[xindex] == "Input") {
            console.log("^^^^^^^^^^^^^^^^^^products.foreach-Exact Sales",element)
          if( typeof parameters.input[xindex] === 'undefined' ) {
              state.products[index].render.message  = "Enter Valid Sales Figure"
              state.products[index].render.type = "is-danger"
              rowvalid = false
              console.log("products.foreach-failed-3",element)
          } else {
              var sales = parseInt(parameters.input[xindex])
              if (isNaN(sales)) {
                state.products[index].render.message  = "Enter Valid Sales Figure"
                state.products[index].render.type = "is-danger"
                rowvalid = false
                console.log("products.foreach-failed-4",element)
              }
            }
          }

      }
        if( rowvalid   ) {
          state.products[index].render.message  = ""
          state.products[index].render.type = "is-info"
        } else {
          state.status = "cart-validating-failed"
        }
      // check that we have a non-zero value for sales
      console.log("products.foreach-end" )
      console.log(state.status)
      console.log(state.products)

    });

    // set the cart to the values
    if( state.status == "cart-validating-success" ) {
      state.orders = []
      state.products.forEach((element, index, array) => {
        console.log("products.foreach",element)
        // the b-fields are indexed according to the row index, not the array index

        var xindex = state.products[index].index
        if (parameters.select[xindex] == "Input") {
            // set the parameters
            var order = { reportversion: "2020-v0.9",   report: state.products[index].cartProduct.report,
              naics: state.products[index].cartProduct.naics, description: state.products[index].cartProduct.description,
              price: element.price, prodindex: xindex , region: "National",
              salesType: "Exact", salesrange: "", salesExact: parameters.input[xindex]
            }
            state.orders.push(order)

        } else {
          var order = {reportversion: "2020-v0.9", report: state.products[index].cartProduct.report,
          price: element.price, prodindex: xindex , region: "National",
            naics: state.products[index].cartProduct.naics, description: state.products[index].cartProduct.description,
            salesType: "Range", salesrange: parameters.select[xindex], salesExact: ""
          }
          state.orders.push(order)
        }
      });
    }

    console.log("orders." )
    console.log(state.orders)

    console.log("**CART_VALIDATE-mutation--end***",state.status);



  },
  [CART_DELETE]: (state,index) => {
    console.log("**CART_DELETE-mutation--start***",state.status);
    console.log(index);
    state.status = "cart-deleting";


    state.products = state.products .filter(function( product ) {
      console.log("Filtering",product);
      return product.index !== index;
    });
      // the b-fields are indexed according to the row index, not the array index

    console.log("Product post-delete",state.products)
    state.status = "cart-deleted-successfully";

    console.log("**CART_DELETE-mutation--end***",state.status);



  },
  [CART_MODE]: (state,mode) => {
    console.log("**CART_MODE-mutation--start***",state.status);
    console.log(mode);
    state.status = "cart-mode-processing";

      state.mode = mode


    state.status = "cart-mode-success";

    console.log("**CART_MODE-mutation--end***",state.status);



  },
  [CART_UPDATE]: (state,myproduct) => {
    console.log("**CART_UPDATE-mutation***");
    console.log(myproduct);
    state.status = "cart-updating";
    state.editable = true;

    state.status = "cart-updated-fail";
    state.products.forEach((product, index, array) => {
          // find the proper naics
          if( product.cartProduct.naics == myproduct.naics && product.cartProduct.report == myproduct.report) {
            state.products[index].cartProduct.salesType = myproduct.salesType;
            state.products[index].cartProduct.salesrange = myproduct.salesrange;
            state.products[index].cartProduct.salesExact = myproduct.salesExact;
            state.status = "cart-success";
        }

      });

  },
  [CART_REQUEST]: (state) => {
    console.log("**CART_REQUEST-mutation***");
    state.status = "loading";
    // state.axiosData = data;
  },
  [CART_SUCCESS]: (state, data) => {
    console.log("**CART_SUCCESS-mutation***");
    state.status = "success";
    state.axiosData = data;
  //  Vue.set(state, "profile", resp);
  },
  [CART_RESTAPI]: (state, api) => {
    console.log("**CART_RESTAPI-mutation***",api);
    state.RESTAPI = api;
  //  Vue.set(state, "profile", resp);
  },
  [CART_ERROR]: state => {
    state.status = "error";
    state.axiosData = {};
  },
  [AUTH_LOGOUT]: state => {
    state.profile = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/cart.js